






























import { Component, Prop, Vue } from 'vue-property-decorator';
import { HttpResp, SnsResp, KinesisResp } from '@/types/core-push';

@Component
export default class DeliveryResponse extends Vue {
  
  @Prop({ default: () => {},  type: Object}) response!: HttpResp | SnsResp | KinesisResp;
  @Prop({ default: '',  type: String}) error!: string;

  get isHttpResp() {
    const httpResp = this.response as HttpResp;
    return httpResp.status !== undefined && httpResp.statusText !== undefined; 
  }

  get httpRespData() {
    const httpResp = this.response as HttpResp;
    return httpResp.data.length < 30 ? httpResp.data : `${httpResp.data.substring(0, 27)}...`;
  }

  get isSnsResp() {
    const snsResp = this.response as SnsResp;
    return snsResp.messageId;
  }

  get isKinesisResp() {
    const kinesisResp = this.response as KinesisResp;
    return kinesisResp.shardId && kinesisResp.seqNumber;
  }
}
